// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import axios from "axios";

export default function (state: string = initialState.locale, action: any) {
    switch (action.type) {
        case ActionTypes.GET_ACTIVE_SETTINGS + ActionTypes.FULFILLED: 
           if (!state) {
            //debugger;
                const defaultLocale = action.payload.data.locale;
               axios.defaults.headers.common['locale'] = defaultLocale;
                return defaultLocale;
            }
            return state;
        case ActionTypes.LOGIN + ActionTypes.FULFILLED:
        case ActionTypes.Login_With_Token + ActionTypes.FULFILLED:
            const user = action.payload.data;
            // return user.locale ? user.locale : state;
            // culture is the locale to connect merlin localization (customer.culture) to the shop's localization (customer.locale)
            return user.culture ? user.culture : state;
        case ActionTypes.SAVE_PROFILE + ActionTypes.FULFILLED:
            const savedUser = action.payload.data;
            const isProfileSaved = savedUser ? true : false;
            if (isProfileSaved) {
                // culture is the locale to connect merlin localization (customer.culture) to the shop's localization (customer.locale)
                axios.defaults.headers.common['locale'] = savedUser.culture; // old was savedUser.locale
                return savedUser.culture; // old was savedUser.culture
            }
            return state;
        case ActionTypes.SAVE_GUEST_PROFILE:
            const newLocale = action.payload;
            if (newLocale !== state) {
                axios.defaults.headers.common['locale'] = newLocale;
                return newLocale;
            }
            return state;
        default:
            return state;
    }
}
